import { CmtsMasterDataCrudShell } from "../components/master-data/index.js";

export function CmtsComplaintSubcategoryPage() {
  return <CmtsMasterDataCrudShell entityKey="complaint-subcategory" />;
}

export default CmtsComplaintSubcategoryPage;
